import React from 'react'
import { Alert, Stack, Typography } from '@mui/material'
import { SmartDialog } from '../../generic/utilities/SmartDialog'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'

/**
 * UnlinkOperationDialog (E5, §8.8) — la confirmación de **desvincular** (CA1.11, S47).
 *
 * `RN-01.17`: desvincular es una acción EXPLÍCITA del usuario sobre UN nodo y se confirma tras leer
 * qué se pierde y qué se conserva. `RN-01.18`: lo que se conserva es la PROCEDENCIA —código y
 * número de versión de origen— como dato histórico; lo que se pierde son los avisos de versión
 * nueva, la adopción y la propuesta a la librería.
 *
 * `RN-01.16` / §8.3: la desvinculación es una **orden**, no una pista. Pero no tiene endpoint
 * propio (§8.6): al confirmar solo queda la intención `UNBIND` del guardado general, y la cabecera
 * "Unlinked from {{code}} v{{version}}" (J19) la fija la RESPUESTA del servidor, que es quien
 * escribe `state`, `originCode` y `originVersionNumber`.
 */
const UnlinkOperationDialog = ({ open = false, code = '', versionNumber = 0, onConfirm = () => {}, onClose = () => {} }) => {
  const { t_ } = useSmartTranslation()

  return (
    <SmartDialog
      setOpen={open}
      title={{ render: <Typography variant='h6'>{t_('Unlink')}</Typography> }}
      acceptLabel={t_('Unlink')}
      acceptCallback={onConfirm}
      cancelCallback={onClose}
      autoClose={false}
      renderComponent={
        <Stack spacing={2} sx={{ mt: 1, minWidth: 360 }} data-testid='unlink-operation-dialog'>
          <Alert severity='warning'>
            {t_('Unlinking keeps the origin as history: the node will no longer receive updates')}
          </Alert>
          {/* La procedencia que se conserva, dicha con la MISMA clave con interpolación que luego
              lucirá la cabecera del nodo (J19): una sola frase, nunca trozos concatenados. */}
          {code
            ? (
              <Typography variant='body2' data-testid='unlink-operation-origin'>
                {t_('Unlinked from {{code}} v{{version}}', { code, version: versionNumber })}
              </Typography>
              )
            : null}
        </Stack>
      }
    />
  )
}

export default UnlinkOperationDialog
